module.exports = __webpack_public_path__ + "img/sbanner_01.4d2d1ab6.jpg";